import { useState } from 'react'
import './ObjectiveWhyToggle.css'

function ObjectiveWhyToggle({
  id,
  detail,
  ariaLabel = 'Pourquoi cet objectif ?',
  children = null
}) {
  const [open, setOpen] = useState(false)
  if (!detail) return children

  return (
    <div className="objective-why-wrap">
      <div className="objective-why-title-row">
        {children ? <div className="objective-why-title-content">{children}</div> : null}
        <button
          type="button"
          className={`objective-why-icon-btn${open ? ' objective-why-icon-btn--open' : ''}`}
          aria-expanded={open}
          aria-controls={id}
          aria-label={ariaLabel}
          onClick={() => setOpen((prev) => !prev)}
        >
          <span aria-hidden="true">?</span>
        </button>
      </div>
      {open ? (
        <p id={id} className="objective-why-detail">
          {detail}
        </p>
      ) : null}
    </div>
  )
}

export default ObjectiveWhyToggle
